export interface Article {
  id: number;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  summary: string;
  content: string;
  views: string;
  date: string;
  tag: string;
  image: string;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: '2026-remen-zongyi-heji',
    title: '2026年最新热门综艺合集·高清完整版在线观看',
    category: '综艺娱乐',
    categorySlug: 'zongyi',
    summary: '汇总2026年度最热门综艺节目资源，包含选秀类、竞技类、旅行类、访谈类等多种类型，所有节目均支持高清画质在线观看，持续更新中。',
    content: `<p>2026年的综艺市场持续火爆，各大平台推出了一系列高质量综艺节目。本文为大家整理了今年最值得观看的综艺节目资源合集。</p>
<h3>选秀竞技类</h3>
<p>今年的选秀节目在赛制和内容上都有很大创新，选手质量普遍提升，舞台效果也更加震撼。从音乐选秀到舞蹈竞技，各种类型应有尽有，满足不同观众的喜好。</p>
<p>特别推荐几档评分超过8.5的高分节目，这些节目不仅有精彩的舞台表演，更有深入人心的选手故事和导师点评。</p>
<h3>旅行真人秀</h3>
<p>旅行类综艺依然是观众最喜爱的类型之一。2026年的旅行节目拓展了更多国际目的地，从东南亚热带海岛到北欧冰雪世界，带观众领略全球美景。</p>
<p>节目组精心设计的互动环节和文化体验，让观众在娱乐的同时也能收获知识和感动。</p>
<h3>访谈脱口秀</h3>
<p>深度访谈类节目在2026年迎来了新的发展，更多行业大咖和思想领袖走进演播室，分享他们的独到见解和人生故事。</p>
<p>这些节目不仅有趣，更有启发意义，适合在闲暇时光细细品味。</p>`,
    views: '128.6万',
    date: '2026-08-07',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20variety%20show%20stage%20with%20colorful%20neon%20lights%20and%20dynamic%20atmosphere%2C%20modern%20studio%20setting%20with%20glowing%20light%20effects%2C%20entertainment%20industry%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20editorial%20style%20with%20soft%20gradients&width=800&height=450&seq=article-zongyi-01&orientation=landscape'
  },
  {
    id: 2,
    slug: 'shuqidang-bikan-dianying',
    title: '暑期档必看电影推荐·十部高分大片免费资源',
    category: '电影资源',
    categorySlug: 'dianying',
    summary: '暑期观影指南！精选十部豆瓣评分8.0以上的高分电影，涵盖动作、喜剧、科幻、悬疑等类型，免费高清资源一键直达。',
    content: `<p>暑期档是电影院线最热闹的时节，今年更是佳片云集。我们为大家精选了十部口碑与票房双丰收的必看电影，所有资源均支持高清画质。</p>
<h3>动作大片</h3>
<p>今年的动作片在特效和场面上都有了质的飞跃。多部国产动作大片在视觉效果上已经达到国际一流水准，打斗场面精彩纷呈，节奏紧凑不拖沓。</p>
<p>推荐关注几部由知名导演执导的系列新作，延续了前作的高水准，同时在剧情深度上有了更多突破。</p>
<h3>喜剧类型</h3>
<p>暑期档的喜剧片总能带来最多的欢笑。2026年的喜剧电影阵容强大，既有实力派演员的精彩演绎，也有新锐导演的创意之作。</p>
<p>这些电影不仅笑点密集，更蕴含了温暖人心的情感内核，非常适合全家一起观看。</p>
<h3>科幻悬疑</h3>
<p>科幻类型片在今年暑期档表现亮眼，多部作品在视觉奇观和故事深度上都取得了很高的评价。悬疑片同样精彩，节奏紧凑的叙事让人欲罢不能。</p>
<p>这些电影值得反复品味，每一遍都能发现新的细节和彩蛋。</p>`,
    views: '96.3万',
    date: '2026-08-06',
    tag: '推荐',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20with%20film%20reel%20and%20movie%20posters%20in%20warm%20theater%20lighting%2C%20golden%20and%20cream%20tones%2C%20vintage%20cinema%20aesthetic%2C%20soft%20ambient%20light%2C%20artistic%20composition%20with%20bokeh%20effects&width=800&height=450&seq=article-dianying-01&orientation=landscape'
  },
  {
    id: 3,
    slug: 'jingdian-guochandianshiju-4k',
    title: '经典国产电视剧全集·4K修复版重温童年记忆',
    category: '电视剧',
    categorySlug: 'dianshiju',
    summary: '多部经典国产电视剧4K修复版上线！重温那些年陪伴我们成长的经典剧集，高清画质带来全新观感体验。',
    content: `<p>经典国产电视剧承载了无数观众的青春记忆。随着4K修复技术的发展，多部经典剧集以全新画质重新上线，让我们可以以更高的品质重温这些经典作品。</p>
<h3>古装经典</h3>
<p>古装剧一直是国产电视剧的重要类型。经过4K修复后，那些精美的服化道和宏大的场景更加震撼。每一帧画面都像一幅精心绘制的古画。</p>
<p>从宫廷权谋到江湖武侠，这些经典古装剧经过时间沉淀，依然散发着独特的魅力。</p>
<h3>都市情感</h3>
<p>90年代和00年代的都市剧记录了一个时代的生活面貌。修复版让这些珍贵影像更加清晰，那些熟悉的面孔和场景仿佛就在昨天。</p>
<p>这些剧集不仅是娱乐，更是一个时代的文化记忆，值得反复回味。</p>
<h3>家庭伦理</h3>
<p>家庭剧是最贴近生活的类型，那些关于亲情、爱情、友情的故事至今仍能引发共鸣。4K修复让这些温暖故事的质感更上一层。</p>`,
    views: '85.2万',
    date: '2026-08-05',
    tag: '经典',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20historical%20drama%20scene%20with%20traditional%20costumes%20and%20elegant%20setting%2C%20warm%20golden%20light%20with%20soft%20shadows%2C%20cinematic%20composition%2C%20nostalgic%20aesthetic%20with%20autumn%20tones&width=800&height=450&seq=article-dianshiju-01&orientation=landscape'
  },
  {
    id: 4,
    slug: '2026-chunjixin-fan-dongman',
    title: '2026年春季新番动漫推荐·精选十部高分作品',
    category: '动漫动画',
    categorySlug: 'dongman',
    summary: '2026年春季新番精彩纷呈！精选十部口碑爆棚的新番动漫，涵盖热血、恋爱、奇幻、日常等题材，附免费观看资源。',
    content: `<p>2026年春季新番季带来了众多令人惊喜的作品。从备受期待的续作到黑马新作，这个季度的动漫市场异常精彩。</p>
<h3>热血战斗</h3>
<p>今年的战斗番在作画质量和剧情节奏上都达到了新高度。多部作品的动作场面流畅震撼，分镜设计精妙，让观众大呼过瘾。</p>
<p>特别推荐几部由顶级制作公司打造的作品，每一集都是视觉盛宴。</p>
<h3>恋爱喜剧</h3>
<p>春季新番中的恋爱喜剧作品甜度满分。细腻的情感描写和恰到好处的喜剧节奏，让这些作品成为观众每周最期待的快乐源泉。</p>
<p>角色塑造立体生动，CP感十足，是放松心情的最佳选择。</p>
<h3>奇幻冒险</h3>
<p>奇幻类作品在今年春季表现尤为突出。独特的世界观设定和精良的制作水准，让观众沉浸其中欲罢不能。</p>
<p>这些作品的想象力丰富，画面精美，代表了当今日本动画制作的最高水平。</p>`,
    views: '73.8万',
    date: '2026-08-07',
    tag: '新番',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20cherry%20blossoms%20and%20vibrant%20characters%2C%20spring%20theme%20with%20soft%20pink%20and%20peach%20tones%2C%20Japanese%20animation%20aesthetic%2C%20dreamy%20atmosphere%20with%20floating%20petals&width=800&height=450&seq=article-dongman-01&orientation=landscape'
  },
  {
    id: 5,
    slug: 'bbc-ziran-jilupian-xilie',
    title: 'BBC自然纪录片系列·震撼视觉的动物世界之旅',
    category: '纪录片',
    categorySlug: 'jilupian',
    summary: 'BBC经典自然纪录片系列高清合集，从非洲草原到深海世界，从极地冰川到热带雨林，带来一场震撼心灵的视觉盛宴。',
    content: `<p>BBC自然纪录片以其卓越的拍摄技术和深刻的自然洞察，成为纪录片领域的标杆。本文汇总了多部BBC经典自然纪录片的高清资源。</p>
<h3>地球脉动系列</h3>
<p>《地球脉动》系列被誉为有史以来最伟大的自然纪录片。采用最先进的拍摄设备，捕捉到许多前所未见的自然奇观。</p>
<p>从高耸的山脉到深邃的海洋，从酷热的沙漠到寒冷的极地，这部纪录片以无与伦比的画面展现了地球的壮美。</p>
<h3>蓝色星球系列</h3>
<p>《蓝色星球》系列聚焦海洋世界，揭开了深海的神秘面纱。令人惊叹的水下摄影技术，让观众得以一窥海洋生物的奇妙生活。</p>
<p>每一帧画面都如同一幅精美的艺术品，配以大卫·爱登堡爵士富有磁性的解说，带来极致的视听享受。</p>
<h3>生命系列</h3>
<p>《生命》系列从微观到宏观，全面展示了地球上生命的多样性和适应能力。高速摄影和微距镜头捕捉到许多肉眼无法看到的精彩瞬间。</p>`,
    views: '62.1万',
    date: '2026-08-04',
    tag: '高清',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20wildlife%20nature%20documentary%20scene%20with%20savanna%20landscape%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20wild%20animals%20in%20natural%20habitat%2C%20cinematic%20aerial%20photography%20style%2C%20rich%20earth%20tones&width=800&height=450&seq=article-jilupian-01&orientation=landscape'
  },
  {
    id: 6,
    slug: 'nba-jihojsai-jingcai-huifang',
    title: 'NBA季后赛精彩回放·全程高清赛事集锦合集',
    category: '体育赛事',
    categorySlug: 'tiyu',
    summary: '2026年NBA季后赛全程高清回放与精彩集锦，收录所有关键比赛，绝杀时刻、逆天暴扣一网打尽。',
    content: `<p>2026年NBA季后赛精彩纷呈，多场比赛打出史诗级的表现。我们整理了本赛季季后赛的所有关键比赛回放和精彩集锦。</p>
<h3>首轮对决</h3>
<p>今年季后赛首轮就上演了多场激烈对决，多支球队战至抢七才分出胜负。精彩的个人表现和团队配合让球迷大呼过瘾。</p>
<p>新秀球员在季后赛舞台上的表现令人惊喜，展现了联盟未来的希望。</p>
<h3>分区决赛</h3>
<p>分区决赛的强度更上一层楼，顶级球星之间的对决堪称经典。绝杀球、关键封盖、华丽的进攻配合，每一个回合都充满悬念。</p>
<p>这些比赛展现了篮球运动的最高水平，值得反复回看。</p>
<h3>总决赛</h3>
<p>总决赛系列赛打满了七场，创造了多项历史纪录。两支球队展现了极高的竞技水平和顽强的斗志。</p>
<p>冠军的归属直到最后一刻才揭晓，堪称近年最精彩的总决赛之一。</p>`,
    views: '91.5万',
    date: '2026-08-06',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20basketball%20game%20scene%20with%20players%20in%20action%20on%20a%20bright%20court%2C%20dramatic%20sports%20lighting%20with%20warm%20amber%20and%20cream%20tones%2C%20professional%20sports%20photography%20style%2C%20motion%20blur%20effect&width=800&height=450&seq=article-tiyu-01&orientation=landscape'
  },
];

export const aboutData = {
  intro: '福利视频网址大全成立于2020年，是国内领先的视频资源导航平台。我们致力于为广大用户提供最新、最快、最全的视频资源入口导航服务，帮助用户高效找到所需的视频内容。',
  mission: '我们的使命是让每个人都能轻松找到想要的视频资源。无论是最新上映的电影、热播的电视剧、精彩的综艺节目，还是高质量的纪录片和教育资源，我们都致力于为您提供最便捷的访问通道。',
  values: [
    { title: '每日更新', desc: '团队每日人工审核更新收录的福利视频网址，确保所有链接的有效性和时效性，让用户永远不会遇到失效链接。' },
    { title: '安全可靠', desc: '我们严格筛选每一个收录的网址资源，优先推荐正规、安全的视频平台，保障用户的观看体验和信息安全。' },
    { title: '免费使用', desc: '本网站完全免费，无需注册即可使用全部功能。我们坚持开放共享的理念，让优质视频资源触手可及。' },
    { title: '用户至上', desc: '以用户体验为核心，不断优化网站功能和内容质量。认真倾听每一位用户的反馈和建议，持续改进服务。' },
  ],
  milestones: [
    { year: '2020', event: '网站正式上线，开始为网友提供视频网址导航服务' },
    { year: '2021', event: '收录网址突破1000个，月访问量超过10万' },
    { year: '2022', event: '推出分类导航功能，用户体验大幅提升' },
    { year: '2023', event: '收录网址突破5000个，日活跃用户突破5万' },
    { year: '2024', event: '网站全面改版升级，推出移动端适配版本' },
    { year: '2025', event: '收录网址突破10000个，累计访问量突破500万' },
    { year: '2026', event: '持续优化服务，月活跃用户突破100万' },
  ],
  testimonials: [
    { name: '王先生', text: '这个导航网站太好用了！以前找个能看的视频网址要翻半天，现在打开这里什么都有，而且每天都在更新，再也不用担心链接失效了。', rating: 5 },
    { name: '李女士', text: '界面简洁清晰，分类也很合理。最重要的是完全免费不用注册，打开就能用。收藏在浏览器书签栏，每天都会打开看看有什么新内容。', rating: 5 },
    { name: '张同学', text: '作为一个电影爱好者，这个网站简直就是宝藏！各种类型的电影资源都有，而且都是高清的。推荐给了身边很多朋友，都说好用。', rating: 5 },
    { name: '刘先生', text: '更新速度真的很快，周末想看的综艺节目周一就能在这里找到最新一期。人工审核的质量也有保证，比很多野鸡导航站靠谱多了。', rating: 4 },
  ],
};